import { TypographyStyles } from '@/styles'
import { Text } from '@/ui'

export const SampleTransactionCardHeader = () => (
  <div className="flex flex-wrap mb-0">
    <div className="w-full md:w-1/12">
      <Text variant={TypographyStyles.EYEBROW}>Date</Text>
    </div>
    <div className="w-full md:w-1/4">
      <Text variant={TypographyStyles.EYEBROW}>Description</Text>
    </div>
    <div className="w-full md:w-1/12">
      <Text variant={TypographyStyles.EYEBROW}>Amount</Text>
    </div>
    <div className="w-full md:w-1/4">
      <Text variant={TypographyStyles.EYEBROW}>Type</Text>
    </div>
    <div className="w-full md:w-1/3">
      <Text variant={TypographyStyles.EYEBROW}>Category</Text>
    </div>
  </div>
)
